import type { IUploadRepository, OfflineQueueEntry } from '../../domain/repositories/IUploadRepository.js';
import type { MediaFolderArgs, MediaFolderBuildArgs } from '../datasources/SupabaseUploadRemoteDataSource.js';
import type { UploadItem } from '../../domain/entities/UploadItem.js';
import type { SupabaseUploadRemoteDataSource } from '../datasources/SupabaseUploadRemoteDataSource.js';
import type { ServerTimeRemoteDataSource } from '../datasources/ServerTimeRemoteDataSource.js';
import type { UploadQueueLocalDataSource } from '../datasources/UploadQueueLocalDataSource.js';

export class UploadRepository implements IUploadRepository {
  constructor(
    private readonly remote: SupabaseUploadRemoteDataSource,
    private readonly serverTime: ServerTimeRemoteDataSource,
    private readonly queue: UploadQueueLocalDataSource,
  ) {}

  uploadFile(item: UploadItem, onProgress: (p: number) => void): Promise<string> {
    return this.remote.upload(
      item.bucket,
      item.remotePath,
      item.file,
      item.file.type || 'application/octet-stream',
      onProgress,
    );
  }

  deleteFile(bucket: string, path: string): Promise<void> {
    return this.remote.delete(bucket, path);
  }

  getMediaFolder(args: MediaFolderArgs): Promise<string | null> {
    return this.remote.getMediaFolder(args);
  }

  getMediaFolderBuild(args: MediaFolderBuildArgs): Promise<string | null> {
    return this.remote.getMediaFolderBuild(args);
  }

  fetchServerTime(): Promise<Date> {
    return this.serverTime.fetchServerTime();
  }

  enqueueOffline(entry: OfflineQueueEntry): Promise<void> {
    return this.queue.enqueue(entry);
  }

  loadOfflineQueue(): Promise<OfflineQueueEntry[]> {
    return this.queue.loadAll();
  }

  removeFromQueue(id: string): Promise<void> {
    return this.queue.remove(id);
  }
}
